import {
  FETCH_COURSE_PROGRESS_REQUEST,
  FETCH_COURSE_PROGRESS_SUCCESS,
  FETCH_COURSE_PROGRESS_FAILURE,
} from './actions';
import { Map } from 'immutable';
import CourseEvent from './model';
import { ApiResponseHelper } from 'omni-common-ui';

export default function courseProgress(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_COURSE_PROGRESS_REQUEST:
      return ApiResponseHelper.create({ loading: true });
    case FETCH_COURSE_PROGRESS_SUCCESS:
      return CourseEvent.create(action.payload);
    case FETCH_COURSE_PROGRESS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/CourseProgress/reducer.js